/* eslint-disable no-undef */
import vars from './helpers';

const isMobile = vars.isMobile();

function clearText(text) {
	return text.toString().trim().replace(/\s+/g, ' ');
}

function getTop(e) {
	let name;
	const select = document.querySelector('.intro__select select ');
	const option = select.querySelectorAll('option');
	if (!isMobile) {
		if ($(e.currentTarget).length) {
			name = $(e.currentTarget).closest('.page').find('.intro__content-text').text();
		} else {
			name = $(e).closest('.page').find('.intro__content-text').text();
		}
	} else {
		// eslint-disable-next-line no-shadow
		const selectedOption = [...option].find((option) => option.selected).text;
		name = selectedOption;
	}

	return name;
}

function getNameSection(e) {
	const name = $(e.currentTarget).closest('[data-section]').data('section');

	return name;
}

function spentOnPage15sec() {
	clearTimeout($(window).data('timeout15Sec'));
	$(window).data('timeout15Sec', setTimeout(() => {
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

function screenInViewport() {
	const scrollTop = vars.$window.scrollTop();
	const scrollBottom = scrollTop + innerHeight;

	$('[data-section]:not(.is-showed)').each((index, promo) => {
		const $currentScreen = $(promo);

		const offsetTop = $currentScreen.offset().top;
		const offsetBottom = offsetTop + $currentScreen.height();

		if (scrollBottom >= offsetTop && scrollTop <= offsetBottom && !$currentScreen.hasClass('is-showed')) {
			$currentScreen.addClass('is-showed');
			const top = getTop($currentScreen);
			const name = $currentScreen.data('section');
			vars.$document.trigger('analytics-screen-progress-view', [name, top]);
		}
	});
}

function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);

		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}
}

vars.$document.on('analytics-screen-progress-view', (e, name, top) => {
	setTimeout(() => {
		const title = vars.learText(name);

		ga('send', 'event', 'main', 'show section', `${top} | ${title}`, {nonInteraction: true});
	}, 0);
});

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	},
});

// header

$('.header__sber, .header__first-talk').on('click', () => {
	ga('send', 'event', 'client link', 'logo header');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.header__rbc').on('click', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});

// share

$('.home [data-social]').on('click', (e) => {
	const socialName = vars.learText(e.currentTarget.dataset.social);
	const name = getTop(e);

	ga('send', 'event', 'share', 'main project share', `${name} | ${socialName}`);
});

$('.article [data-social]').on('click', (e) => {
	const socialName = vars.learText(e.currentTarget.dataset.social);
	const name = $(e.currentTarget).closest('.article').find('.article__title').text();

	ga('send', 'event', 'share', 'article project share', `${name} | ${socialName}`);
});

$('.related__button').on('click', (e) => {
	const title = $(e.currentTarget).closest('.related__item').find('.related__title').text();
	const name = getTop(e);

	ga('send', 'event', 'main', 'see also click', `${name} | ${title}`, {nonInteraction: false});
});

$('.alternative__button').on('click', (e) => {
	const top = getTop(e);
	const title = getNameSection(e);

	ga('send', 'event', 'main', 'alternative opinion read click', `${top} | ${title}`, {nonInteraction: false});
});

$('.solutions__button').on('click', (e) => {
	const top = getTop(e);

	ga('send', 'event', 'client link', 'main sberfirst know more', `${top}`);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.solutions__video .video__play').on('click', (e) => {
	const title = $(e.currentTarget).data('title');
	const top = getTop(e);

	ga('send', 'event', 'main', 'video translation click', `${top} | ${title}`, {nonInteraction: false});
});

$('.intro__video .video__play').on('click', (e) => {
	const title = $(e.currentTarget).data('title');
	const top = getTop(e);

	ga('send', 'event', 'main', 'video topline click', `${top} | ${title}`, {nonInteraction: false});
});

$('.intro__test, .intro__opinion, .intro__podcast a, .intro__person-button').on('click', (e) => {
	const top = getTop(e);
	let title = $(e.currentTarget).data('name');
	ga('send', 'event', 'main', 'preview topline click', `${top} | ${title}`, {nonInteraction: false});
});

$('.intro__person-arrow, [data-link="История инвестора"]').on('click', (e) => {
	const name = $(e.currentTarget).closest('.intro__person').find('.intro__person-name').text();
	const top = getTop(e);

	ga('send', 'event', 'main', 'hero topline click', `${top}| ${name}`, {nonInteraction: false});
});

vars.$document.on('test-start', () => {
	ga('send', 'event', 'test', 'start', {nonInteraction: true});
	ga('rbcspec.send', 'event', 'test', 'start');
}).on('test-question-show', (e, stepIndex, title, question) => {
	ga('send', 'event', 'test', `question show ${stepIndex}`, `${title} | ${clearText(question)}`, {nonInteraction: true});
}).on('test-result', (e, result, count) => {
	ga('send', 'event', 'test', 'finish', result, count);
	ga('rbcspec.send', 'event', 'test', 'finish', result);
}).on('test-reload', () => {
	ga('send', 'event', 'test', 'resume');
}).on('test-answer', (e, step, answer) => {
	ga('send', 'event', 'test', `question answer ${step}`, answer);
});

$('.test__description--result a').on('click', (e) => {
	let name = $(e.currentTarget).text();

	ga('send', 'event', 'client link', 'test final text link', name);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.test__share .share__button').on('click', (e) => {
	let name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'test final share', name);
});

vars.$window.on('audio-play', (evt, name) => {
	ga('send', 'event', 'audio', 'play', `${name}`, {nonInteraction: false});
});

vars.$window.on('audio-end', (evt, name) => {
	ga('send', 'event', 'audio', 'finish', `${name}`);
});

vars.$window.on('audio-interval', (evt, name) => {
	ga('send', 'event', 'audio', 'timing 10s', `${name}`, 10);
});

$('.sbertalk .video').on('click', (e) => {
	const name = 'Иммунитет инвестора: как оценить риски и защитить вложения';
	const top = getTop(e);
	ga('send', 'event', 'main', 'video bottom click', `${top}| ${name}`, {nonInteraction: false});
});

$('.intro__person-text a').on('click', (e) => {
	const name = $(e.currentTarget).closest('.intro__person').find('.intro__person-name').text();
	const top = getTop(e);

	ga('send', 'event', 'client link', 'main hero topline link click', `${top}| ${name}`);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.sbertalk__list-item a').on('click', (e) => {
	const name = $(e.currentTarget).text();
	const top = getTop(e);
	ga('send', 'event', 'main', 'topics list bottom click', `${top}| ${name}`, {nonInteraction: false});
});

$(document).on('click', '.podcasts__text a', (e) => {
	const target = $(e.currentTarget);
	const name = target.closest('.podcasts').find('.podcasts__caption').text();
	ga('send', 'event', 'client link', 'podcast hero link click', `ПОДКАСТЫ | ${name}`);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.step__person-description a').on('click', (e) => {
	const name = $(e.currentTarget).closest('.step__person').find('.step__person-name').text();
	const top = getTop(e);

	ga('send', 'event', 'client link', 'main expert link click', `${top}| ${name}`);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.conclusion__text a').on('click', (e) => {
	const name = $(e.currentTarget).text();
	const top = getTop(e);
	ga('send', 'event', 'client link', 'main plan action plan link click', `${top}| ${name}`);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

// $('.').on('click', () => {

// });
screenInViewport();
spentOnPage15sec();
vars.$window.on('scroll.analytics', screenInViewport);

export default {
	spentOnPage15sec,
	virtualHit,
};

